export const InitialData = {
  notificaitonSocket: undefined,
}